import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Menu, ArrowLeft } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import Sidebar from "@/components/Sidebar";

export default function AppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { isImpersonating, stopImpersonation, user } = useAuth();

  // Close sidebar on route change (mobile)
  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  return (
    <div className="flex h-screen bg-slate-50">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}
      {/* Sidebar */}
      <div className={`
        fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-200 ease-in-out lg:relative lg:translate-x-0
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
      `}>
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>
      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Impersonation banner */}
        {isImpersonating && (
          <div className="bg-violet-600 text-white px-4 py-2 flex items-center justify-between text-sm shrink-0" data-testid="impersonation-banner">
            <span>Vous êtes connecté en tant que <strong>{user?.name}</strong> ({user?.email})</span>
            <button
              onClick={stopImpersonation}
              className="flex items-center gap-1.5 bg-white/20 hover:bg-white/30 px-3 py-1 rounded-md transition-colors text-xs font-medium"
              data-testid="stop-impersonation-btn"
            >
              <ArrowLeft className="w-3.5 h-3.5" /> Revenir
            </button>
          </div>
        )}
        {/* Mobile header */}
        <div className="lg:hidden flex items-center gap-3 px-4 py-3 bg-slate-900 text-white shrink-0" data-testid="mobile-header">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-1.5 rounded-md hover:bg-slate-800"
            data-testid="hamburger-btn"
          >
            <Menu className="w-5 h-5" />
          </button>
          <img src="/jvc-logo.png" alt="JVC" className="w-7 h-7 rounded object-contain bg-white p-0.5" />
          <span className="font-barlow text-sm font-bold tracking-tight uppercase">SAS J.V.C</span>
        </div>
        <main className="flex-1 overflow-auto">{children}</main>
      </div>
    </div>
  );
}
